import { render, staticRenderFns } from "./scoreOrder.vue?vue&type=template&id=f8507358"
import script from "./scoreOrder.vue?vue&type=script&lang=js"
export * from "./scoreOrder.vue?vue&type=script&lang=js"
import style0 from "./scoreOrder.vue?vue&type=style&index=0&id=f8507358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports